"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _card_component = require("./global_components/card_component");

var _card_component2 = _interopRequireDefault(_card_component);

var _string_utility = require("../../../packages/common-utilities/src/string_utility.js");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility");

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _reactIntl = require("react-intl");

var _table_component = require("./global_components/table_component");

var _table_component2 = _interopRequireDefault(_table_component);

var _button = require("./global_components/button");

var _button2 = _interopRequireDefault(_button);

var _tracking_utility = require("../../../packages/common-utilities/src/tracking_utility");

var _collection_utility = require("../../../packages/common-utilities/src/collection_utility");

var _date_formatter = require("../../../packages/common-utilities/src/date_formatter");

var _date_formatter2 = _interopRequireDefault(_date_formatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PricingCompositionHistory = function (_React$PureComponent) {
  _inherits(PricingCompositionHistory, _React$PureComponent);

  function PricingCompositionHistory(props) {
    _classCallCheck(this, PricingCompositionHistory);

    return _possibleConstructorReturn(this, (PricingCompositionHistory.__proto__ || Object.getPrototypeOf(PricingCompositionHistory)).call(this, props));
  }

  _createClass(PricingCompositionHistory, [{
    key: "generateTableHeaders",
    value: function generateTableHeaders() {
      var markup = [];
      markup.push(_react2.default.createElement(
        "th",
        { className: "border-top-none tag",
          "data-testid": "pdp-pricing-composition-history-column-header-date" },
        "\u65E5\u671F"
      ));
      markup.push(_react2.default.createElement(
        "th",
        { className: "border-top-none tag text-right",
          "data-testid": "pdp-pricing-composition-history-column-header-ipo-price" },
        "\u57FA\u672C\u9762\u984D (A)"
      ));
      markup.push(_react2.default.createElement(
        "th",
        { className: "border-top-none tag text-right",
          "data-testid": "pdp-pricing-composition-history-column-header-income-price" },
        "\u6536\u76CA\u5E73\u6E96\u91D1 (B)"
      ));
      markup.push(_react2.default.createElement(
        "th",
        { className: "border-top-none tag text-right",
          "data-testid": "pdp-pricing-composition-history-column-header-cap-gain-loss-price" },
        "\u8CC7\u672C\u640D\u76CA\u5E73\u6E96\u91D1 (C)"
      ));
      markup.push(_react2.default.createElement(
        "th",
        { className: "border-top-none tag text-right",
          "data-testid": "pdp-pricing-composition-history-column-header-nav-price" },
        "\u57FA\u91D1\u6DE8\u503C (A +B + C)"
      ));

      return markup;
    }
  }, {
    key: "generateTableRows",
    value: function generateTableRows(data, dataTestLabel) {
      var _this2 = this;

      var fields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var tableRows = [];

      var textRightOrEmptyString = function textRightOrEmptyString(columnIndex) {
        return columnIndex > 0 ? "text-right" : "";
      };

      var tableData = [];
      var columnIndex = 0;

      if ((0, _ramda.or)(!data, _collection_utility.CollectionUtility.size(data) < 1)) {
        return null;
      }

      _collection_utility.CollectionUtility.forEachIndexed(data, function (item, index) {
        var tableRow = _react2.default.createElement(
          "tr",
          { className: "category row-divider", "data-testid": dataTestLabel + "-data-" + index, id: dataTestLabel + "-data-" + index },
          tableData
        );
        columnIndex = 0;
        _collection_utility.CollectionUtility.forEachIndexed(fields, function (value) {

          var data = item[value];
          if (/date/gi.test(value)) {
            if (_collection_utility.CollectionUtility.includes((0, _functional_utility.pathOrEmptyArray)(["formattingRules"], _this2.props), 'HISTORICAL_NAV_CHART_DATE_FORMAT_YYYY_MM_DD')) {
              data = _date_formatter2.default.getDateInYYYYMMDDSlashFormat(_functional_utility2.default.returnDashOrValue(data));
            } else {
              data = _date_formatter2.default.getDateInDDMMYYYSlashFormat(_functional_utility2.default.returnDashOrValue(data));
            }
          }

          tableData.push(_react2.default.createElement(
            "td",
            {
              className: "border-top-none " + textRightOrEmptyString(columnIndex) },
            data
          ));
          columnIndex++;
        });
        tableRows.push(tableRow);
        tableData = [];
      });

      return tableRows;
    }
  }, {
    key: "render",
    value: function render() {
      if ((0, _functional_utility.isNilOrEmpty)(this.props.data)) {
        return null;
      }

      var columnMapping = {
        "NAV DATE": "navDate",
        "IPO PRICE": "ipoPrice",
        "INCOME PRICE": "incomePrice",
        "CAP GAIN LOSS": "capGainLoss",
        "NAV PRICE": "navPrice"
      };

      var headerTitle = _string_utility2.default.renderFormattedLabel("淨值組成項目", "pdp-historical-pricing-composition-history-header-label");

      var excelServiceURL = encodeURI(this.props.gaiaRedirectUrl + '/excel?type=pricingCompositionHistory' + '&cusip=' + this.props.cusip + '&country=' + this.props.country + '&role=' + this.props.role + '&locale=' + _string_utility2.default.generateLocale());

      return _react2.default.createElement(
        "div",
        { className: "pricing-composition-history-card" },
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: headerTitle,
            headerTitleId: "pricing-composition-history-card-title-id",
            headerTitleLabel: "pricing-composition-history-label",
            breakpoint: this.props.breakpoint,
            dataTest: "data-test-pricing-composition-history-card",
            disclosureText: this.props.disclosureText,
            placementId: "pdpCardNAVComposition"
          },
          _react2.default.createElement(_table_component2.default, {
            tableHeaders: this.generateTableHeaders(),
            tableRows: this.generateTableRows(this.props.data, 'pricing-composition-history', columnMapping),
            breakpoint: this.props.breakpoint
          }),
          _react2.default.createElement(_button2.default, {
            role: this.props.role,
            dataTest: "pricing-composition-history-card-download-data\"",
            downloadURL: excelServiceURL,
            dataTestLink: "pricing-composition-history-card-download-link",
            text: _string_utility2.default.renderFormattedLabel("Download data", "distribution-tab-download-data"),
            additionalClassName: "mobile-full-width",
            callBack: function callBack() {
              return _tracking_utility.TrackingUtility.trackEvent({
                "eventCategory": "pdp",
                "eventAction": "pricing-composition-history",
                "eventLabel": "download data"
              });
            }
          })
        )
      );
    }
  }]);

  return PricingCompositionHistory;
}(_react2.default.PureComponent);

exports.default = (0, _reactIntl.injectIntl)(PricingCompositionHistory, { withRef: true });